import { render, staticRenderFns } from "./fisdegistir.vue?vue&type=template&id=40e20d1a"
import script from "./fisdegistir.vue?vue&type=script&lang=js"
export * from "./fisdegistir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports